import { Action } from 'redux';
import { BffLoginHistory } from '@lucky7ventures/bff-types';

export enum LoginHistoryActionType {
  GetLoginHistory = 'GET_LOGIN_HISTORY',
  GetLoginHistorySuccess = 'GET_LOGIN_HISTORY_SUCCESS',
  GetLoginHistoryError = 'GET_LOGIN_HISTORY_ERROR',
  Reset = 'RESET_LOGIN_HISTORY',
}

export type GetLoginHistoryAction = Action<LoginHistoryActionType.GetLoginHistory>;
export type GetLoginHistorySuccessAction = Action<LoginHistoryActionType.GetLoginHistorySuccess> & {
  loginHistory: BffLoginHistory[];
};
export type GetLoginHistoryErrorAction = Action<LoginHistoryActionType.GetLoginHistoryError>;
export type ResetLoginHistoryAction = Action<LoginHistoryActionType.Reset>;

export type LoginHistoryActions =
  | GetLoginHistoryAction
  | GetLoginHistorySuccessAction
  | GetLoginHistoryErrorAction
  | ResetLoginHistoryAction;

export const getLoginHistory = (): GetLoginHistoryAction => ({
  type: LoginHistoryActionType.GetLoginHistory,
});

export const getLoginHistorySuccess = (
  loginHistory: BffLoginHistory[],
): GetLoginHistorySuccessAction => ({
  type: LoginHistoryActionType.GetLoginHistorySuccess,
  loginHistory,
});

export const getLoginHistoryError = (): GetLoginHistoryErrorAction => ({
  type: LoginHistoryActionType.GetLoginHistoryError,
});

export const resetLoginHistory = (): ResetLoginHistoryAction => ({
  type: LoginHistoryActionType.Reset,
});
